var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconFastForward = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", { transform: "translate(-1.417 -4.667)" },
                React.createElement("path", { d: "M17.5,27.2l9.8-7.6l-9.8-7.6V27.2z" }),
                React.createElement("path", { d: "M5.6,27.2l9.8-7.6l-9.8-7.6V27.2z" })))));
});
export default IconFastForward;
//# sourceMappingURL=IconFastForward.js.map